// localStorage potrafi rzucić (tryb prywatny, zablokowane dane strony) - wtedy gra
// działa dalej, tylko bez zapamiętanego rekordu i adresu, na który poszedł voucher.

export const BEST_KEY = 'rpm_best';
export const CLAIM_KEY = 'rpm_claimed_email';
// Kiedy backend odpowiedział pool_exhausted (ms) - po tym czasie przestajemy mu wierzyć,
// gdyby backend dołożył kodów do puli.
export const POOL_KEY = 'rpm_pool_exhausted_at';
export const POOL_TTL = 6 * 36e5;

export function readStorage(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

export function writeStorage(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
        // brak dostępu do storage - ignorujemy
    }
}

// Podmienia %placeholdery% w komunikatach z game_config.texts.
export function fillText(template, values) {
    return Object.keys(values).reduce(
        (text, key) => text.split(`%${key}%`).join(String(values[key])),
        template ?? ''
    );
}

// Polska odmiana po liczbie: 1 punkt, 2-4 punkty (bez 12-14), reszta punktów.
export function pluralForm(count, one, few, many) {
    const mod10 = count % 10;
    const mod100 = count % 100;

    if (count === 1) {
        return one;
    }

    return mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14) ? few : many;
}
